import React, { useRef, useState } from "react";
import styles from "./FloorPlan.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import uploadImg from "../../../../assets/uploadFloorpng.png";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
const FloorPlan = () => {
  const eventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [img, setImg] = useState("");
  const hiddenFileInput = useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const dispatch = useDispatch();

  console.log("eventDetails", eventDetails);

  const createVenue = () => {
    if (img) {
      dispatch(
        EventPlanningMiddleware.createEventVenue({
          id: eventDetails?.id,
          image: img,
        })
      ).then(() => setImg(null));
    } else {
      dispatch(
        showAlert({
          type: "Error",
          message: "Select Venue Image",
        })
      );
      return;
    }
  };

  return (
    <div className={styles.mainCont}>
      <TextComponent text={"Floor Plan"} textClass={styles.heading} />
      <div className={styles.content}>
        <div
          className={img ? styles.imageCont : styles.UploadimageCont}
          onClick={handleClick}
        >
          <img
            className={img ? styles.imgDiv : styles.uploadImg}
            src={
              img
                ? URL.createObjectURL(img)
                : eventDetails?.venue?.image
                ? eventDetails?.venue?.image
                : uploadImg
            }
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImg(e.target.files[0])}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
        </div>
        <div className={styles.btnDiv}>
          <SubmitButton
            title={
              img
                ? "Save Image"
                : eventDetails?.venue?.image
                ? "Change Image"
                : "Upload Image"
            }
            outline={eventDetails?.venue?.image && !img}
            btnClass={styles.btn}
            onClick={!img ? handleClick : createVenue}
          />
        </div>
      </div>
    </div>
  );
};

export default FloorPlan;
